
export const isFinance = (vehicle: any) => {
  return !!Object.keys(vehicle.finance_data).length
}